/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0 !important;
  visibility: hidden !important;
  transition-property: opacity, visiblity !important;
  transition-duration: 400ms !important;
  transition-timing-function: ease-in-out !important;
  z-index: -9999999 !important;

  // IE Edge 18 fix
  @supports (-ms-ime-align: auto) {
    visibility: visible;
  }

  @include slotted-margins("*:not([slot])");
}

:host([is-active="true"]) {
  opacity: 1 !important;
  visibility: visible !important;
  z-index: auto !important;
}

.#{$prefix}mcs-content {
  color: v(textColor);

  &.#{$prefix}has-promo-flag {
    margin-top: 26px;

    &.#{$prefix}promo-flag-small {
      margin-top: 18px;
    }
  }
}

.#{$prefix}mcs-promo-flag {
  position: absolute;
  top: -40px;
  transform: translateY(-50%);
  max-width: 100%;

  @include for-size(desktop) {
    top: -32px;
  }

  @include for-size(tablet-or-smaller) {
    top: -24px;
  }

  &.#{$prefix}left {
    left: -40px;

    @include for-size(desktop) {
      left: -32px;
    }

    @include for-size(tablet-or-smaller) {
      left: -24px;
    }
  }

  &.#{$prefix}right {
    right: -40px;

    @include for-size(desktop) {
      right: -32px;
    }

    @include for-size(tablet-or-smaller) {
      right: -24px;
    }
  }

  &.#{$prefix}center {
    left: 0;
    width: calc(100% + 80px);
    margin-left: -40px;
    max-width: none;

    @include for-size(desktop) {
      width: calc(100% + 64px);
      margin-left: -32px;
    }

    @include for-size(tablet-or-smaller) {
      width: calc(100% + 48px);
      margin-left: -24px;
    }
  }
}

::slotted([slot="stage-item-image"]) {
  display: none;
}

::slotted([slot="stage-item-background"]) {
  display: none;
}
